import { FieldShell } from '@today/ui-components'
import { Input } from '@today/ui-primitives'
import type { ReactElement } from 'react'

/**
 * Field helpers of the organization organisms that the product helpers lack: a
 * labelled checkbox and a labelled date input. Text/select/textarea fields reuse
 * `../product/product-fields`.
 */

/** A labelled native checkbox. */
export function CheckboxInput(props: {
	label: string
	checked: boolean
	disabled?: boolean
	onChange: (checked: boolean) => void
}): ReactElement {
	return (
		<label className="flex items-center gap-2 text-ds-sm text-ds-text">
			<input
				type="checkbox"
				checked={props.checked}
				disabled={props.disabled}
				onChange={(e) => props.onChange(e.target.checked)}
			/>
			{props.label}
		</label>
	)
}

/** A labelled date input (YYYY-MM-DD) with an optional error. */
export function DateInput(props: {
	label: string
	value: string
	error?: string
	onChange: (value: string) => void
}): ReactElement {
	return (
		<FieldShell label={props.label} error={props.error}>
			<Input type="date" value={props.value} onChange={(e) => props.onChange(e.target.value)} />
		</FieldShell>
	)
}
